import { TemplateData, TemplateParams } from '.';

const achievementExpirationOthers = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{achievementAdminUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementExpirationIntroAdmin}
      </p>
      <p>
        {{usersList}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementExpirationSubjectAdmin}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    achievementAdminUrl: {
      label: messages.achievementAdminLink,
      example: `${serverConfig.adminUrl}/admin/achievements/1`
    },
    usersList: {
      label: messages.emailExpiringAchievementsUsersList
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeExternalAchievementExpirationOthers
});

export default achievementExpirationOthers;
